import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Avatar, Box, Flex, rem, StyleProps, Text } from '@bonusly/design-system';
import { Recipient } from '@bonusly/recipient-entities';

interface RecipientOptionProps extends StyleProps {
	recipient: Recipient;
}

export const RecipientOption: FC<RecipientOptionProps> = ({ recipient, ...rest }: RecipientOptionProps) => {
	const { t } = useTranslation('components');
	const isGroup = recipient.type === 'group';
	const isEveryone = recipient.dimension === 'everyone';
	const groupTypeText = t(`group_popover.${recipient.dimension}`);
	const hasDepartment = !!recipient.department;

	return (
		<Flex {...rest}>
			<Avatar name={recipient.displayName} mr={3} size="lg" boxSize={rem(44)} src={recipient.imageSrc} hideOverlay {...(isGroup && { bg: 'transparent' })} />

			<Box flex={1} minWidth={0} textAlign="left">
				<Text fontSize="md" fontWeight="medium" lineHeight={6} overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
					{recipient.displayName}
				</Text>

				<Text color="text.softest" fontSize="sm" fontWeight="normal" lineHeight={5} overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
					{isGroup ? (
						<>
							{isEveryone ? '' : `${groupTypeText} • `}
							{recipient.userIds?.length} {t('people')}
						</>
					) : (
						<>
							@{recipient.username}
							{hasDepartment && (
								<Text as="span" textTransform="capitalize" pl={1} fontSize="sm" color="text.softest">
									• {recipient.department}
								</Text>
							)}
						</>
					)}
				</Text>
			</Box>
		</Flex>
	);
};
